import { render, staticRenderFns } from "./CreatePart2.vue?vue&type=template&id=0fda7b4c&"
import script from "./CreatePart2.vue?vue&type=script&lang=js&"
export * from "./CreatePart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports